export interface CreatePatientPayload {
  firstname: string; // required
  lastname: string; // required
  gender?: string; // required
  birthdate: string | null;
  pathologies?: number[];  // required
  email: string;
  id_number: number | null;
  phone_number: string;
  tutor_name?: string | null;
  address?: string;
  health_insurance_id?: number | null;
  prepaid_id?: number | null;
  id_card?: number | null;
  medic_id: number | null;
}

export interface StudiesDocumentsPayload {
  fileName: string;
  file?: File | null;
  observations: string;
  studyId?: number
}
